import { SyncAction } from '@shared/models/sync/sync-action';

// Generic registry of synced children, keyed by `${type}:${id}` (see toRefKey). Holds only
// identity + sync state, never business data (title, thumbnail) nor transport detail (session token,
// preview) — those are resolved at read time from their own slices. One entry per synced object; a
// parent (sequence) has no entry of its own, it emerges from grouping.
export type SyncState = {
  [key: string]: SyncAction;
};

export const initialSyncState: SyncState = {};
